import { useAuth } from "$/lib/providers/AuthProvider";

const MINIMUM_YEAR_MINUS =
  import.meta.env.VITE_USER_NODE_ENV === "production" ? 2 : 2;

export function useMinimumYearSelector() {
  const { user } = useAuth();

  /* Keep this line for future use, we might rollback to it */
  // return user ? user.onBoardingYear - 2 : new Date().getFullYear();
  return user
    ? Math.max(
        new Date(user.createdAt).getFullYear() - MINIMUM_YEAR_MINUS,
        new Date(user.businessStartDate).getFullYear(),
      )
    : new Date().getFullYear();
}
